import { render, staticRenderFns } from "./gwzHeader.vue?vue&type=template&id=50aa64ee&scoped=true"
import script from "./gwzHeader.vue?vue&type=script&lang=js"
export * from "./gwzHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa64ee",
  null
  
)

export default component.exports